module.exports = __webpack_public_path__ + "img/rule-bg-zh.b0ae9993.png";